import React, { useCallback } from 'react'

import { VALIDATIONS } from 'utils'
import createId from 'hooks/useId'

interface IRequeriments {
  id: string
  description: string
  satisfied: boolean
}

interface IPasswordRequerimentsChecklistProps {
  children: (_requeriments: IRequeriments[]) => React.ReactNode
  password: string
}

const PasswordRequerimentsChecklist: React.FC<IPasswordRequerimentsChecklistProps> = ({
  children,
  password,
}) => {
  const requeriments = useCallback((): IRequeriments[] => {
    return [
      {
        id: createId(),
        description: 'Senha deve ter no mínimo 8 caracteres',
        satisfied: VALIDATIONS.minCharacters(password, 8),
      },
      {
        id: createId(),
        description: 'Senha deve ter no mínimo 1 caractere em caixa alta',
        satisfied: VALIDATIONS.upperCaseCharacter(password, 1),
      },
      {
        id: createId(),
        description: 'Senha deve ter no mínimo 2 letras',
        satisfied: VALIDATIONS.minLetters(password, 2),
      },
      {
        id: createId(),
        description: 'Senha deve ter no mínimo 1 caractere em caixa baixa',
        satisfied: VALIDATIONS.lowerCaseCharacter(password, 1),
      },
      {
        id: createId(),
        description: 'Senha deve ter no mínimo 2 números',
        satisfied: VALIDATIONS.minNumbers(password, 2),
      },
      {
        id: createId(),
        description: 'Senha não deve haver sequências de caracteres',
        satisfied: VALIDATIONS.noRepeatWords(password),
      },
      {
        id: createId(),
        description: 'Senha não deve conter espaços em branco',
        satisfied: VALIDATIONS.notContentSpaces(password),
      },
    ] 
  }, [password])

  return (
    <>
      {children(requeriments())}
    </>
  ) 
}

export default PasswordRequerimentsChecklist
